<script>
import FormFilterGroup from './FormFilterGroup.vue';
import EventSelection from './EventSelection.vue';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator.vue';
import SelectOptions from '../SelectOptions/SelectOptions.vue';
import SavePresetButton from './common/SavePresetButton';
import t from './state/types';

export default {
  name: 'FormFilters',
  components: {
    EventSelection,
    FormFilterGroup,
    LoadingIndicator,
    SelectOptions,
    SavePresetButton,
  },
  props: {
    categories: {
      type: Array,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
    },
    settings: {
      type: Array,
      required: true,
    },
    metrics: {
      type: Object,
      required: true,
    },
    runnerCount: {
      type: Number,
      default: 0,
    },
    status: {
      type: String,
      required: true,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    dateSortOptions: {
      type: Array,
      default: () => [],
    },
    showFilterModal: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      isOpen: false,
      currentSort: '',
    };
  },
  computed: {
    activeSettings: function() {
      let count = 0;

      this.settings.map(setting => {
        if (Number(setting.value) > 0) {
          count++;
        }
      });

      return count ? ` (${count})` : '';
    },
    runnerCountSuffix: function() {
      return this.runnerCount === 1 ? '' : 's';
    },
  },
  watch: {
    currentSort(value) {
      this.$emit('changeSort', value);
    },
    showFilterModal() {
      this.isOpen = true;
    },
  },
  methods: {
    categoryFilters: function(categoryId) {
      return this.settings.filter(filter => filter.category === categoryId);
    },
    changeSort: function(value) {
      this.currentSort = value;
      this.$emit('dateFilterChange', value);
    },
    filterChange: function(filter, metric, value, range) {
      this.$emit('filterChange', filter, metric, value, range);
    },
    isFetching: function() {
      return this.status === t.FETCH_RESULTS;
    },
    isFirstLoad: function() {
      return this.status === t.STARTED;
    },
    reset: function() {
      this.$emit('reset');
    },
    submitSettings: function() {
      this.$emit('submitSettings');
      this.toggle();
    },
    toggle: function() {
      this.isOpen = !this.isOpen;
      this.$emit('toggleModal', this.isOpen);

      if (this.isOpen) {
        document.getElementsByTagName('html')[0].style.overflow = 'hidden';
        document.getElementsByTagName('html')[0].style.height = '100%';
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        document.getElementsByTagName('body')[0].style.height = '100%';
      } else {
        document.getElementsByTagName('html')[0].style.overflow = '';
        document.getElementsByTagName('html')[0].style.height = '';
        document.getElementsByTagName('body')[0].style.overflow = '';
        document.getElementsByTagName('body')[0].style.height = '';
      }
    },
  },
};
</script>
<template>
  <div :class="{ open: isOpen }">
    <form class="form-finder__settings">
      <h2>
        Filtering
        <SavePresetButton />
        <button class="close" @click.prevent="toggle">Close</button>
      </h2>
      <div class="form-finder__settings_wrap">
        <button
          class="form-finder__button form-finder__button-reset"
          @click.prevent="reset"
        >Clear Filters</button>
        <FormFilterGroup
          v-for="category in categories"
          :key="category.id"
          :name="category.name"
          :filters="categoryFilters(category.id)"
          :metrics="metrics"
          :groups="groups"
          @filterChange="filterChange"
        />
        <div class="form-finder__actions">
          <button
            v-if="isFirstLoad()"
            class="form-finder__button form-finder__button-submit"
            @click.prevent="submitSettings"
          >See {{ totalCount }} runners</button>
          <LoadingIndicator v-else-if="isFetching()" />
          <button
            v-else
            class="form-finder__button form-finder__button-submit"
            @click.prevent="submitSettings"
          >See {{ runnerCount }} runner{{ runnerCountSuffix }}</button>
        </div>
      </div>
    </form>
    <button class="form-finder__settings-toggle" @click.prevent="toggle">Form Filters</button>
    <SelectOptions
      :options="dateSortOptions"
      :value="currentSort"
      class="form-finder__sort"
      @input="changeSort"
    >Select day</SelectOptions>
  </div>
</template>
